module.exports = __webpack_public_path__ + "static/media/mic.1c27f2ca.jpg";